// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3e920a38","389":"4a65aed3","453":"219f9990","455":"23f9e55c","632":"b19340c6","809":"c832eb74","977":"0f25e672"}[chunkId] + ".chunk.js";
};